/* eslint-disable react/jsx-no-useless-fragment */
import { APP_ENV, CategoryItemsProps, Template } from '@zeus/shared';
import { BoxComponent } from '../../../../../base/box/Box';
import { TypographyComponent } from '../../../../../base/typography/Typography';
//import { GridComponent } from '../../../../../base/grid/Grid';
import OutOfStock from '../OutOfStock';
import { memo, useEffect, useState } from 'react';
import { getScaleSize, isBetweenRange } from '../../../../../utils/utils';
import { TEMPLATE_6_MODIFIERS } from '../../../../../utils/consts';
import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { Grid as GridComponent } from '../../../../../base19/grid/Grid';

interface Item extends CategoryItemsProps {
  hasValidModifiers: boolean;
}

interface ItemProps {
  template: Template | null;
  item: Item;
  development?: boolean;
  lastItemIndex: number;
  index: number;
  timezone?: string;
  scale?: number;
  hasAnyModifier: boolean;
  tenantId?: number;
  fontFamily?: string;
  categoryId: number;
}

const Item = ({
  template,
  item,
  development,
  timezone,
  index,
  scale = 1,
  lastItemIndex,
  hasAnyModifier,
  tenantId,
  fontFamily: fontFamilyProp,
  categoryId,
}: ItemProps) => {
  const [active, setActive] = useState<boolean | null>(true);
  const { normalizePixels } = useNormalizedPixels();

  useEffect(() => {
    if (development === false) {
      const intervalId = setInterval(() => {
        setActive(isBetweenRange(item.schedules, timezone));
      }, 10000);

      return () => clearInterval(intervalId);
    }
  }, []);

  const getMargin = () => {
    if (isDescription) {
      return { marginTop: getScaleSize(normalizePixels(15, 'height'), scale) };
    } else {
      return { marginTop: getScaleSize(normalizePixels(20, 'height'), scale) };
    }
  };

  const getMaxWidth = () => {
    if (isItemPriceEnabled) {
      if (item?.outOfStock) {
        return item?.hasValidModifiers ? '48%' : '80%';
      } else {
        return '100%';
      }
    } else {
      if (item?.outOfStock) {
        return '80%';
      } else {
        return '100%';
      }
    }
  };

  const isItemPriceEnabled = template?.itemPrice && template.itemPrice.isEnabled;
  const isDevelopment = development ? true : isBetweenRange(item.schedules, timezone);
  const isDescription = template?.itemDescription?.isEnabled;
  // const fontFamily = fontFamilyProp || extractFontFamilyFromUrl(template?.fontFamily);
  const fontFamily = template?.fontFamilyName;
  const itemId = `item-${item.id}-category-${categoryId}`;

  return (
    active && (
      <>
        {isDevelopment && (
          <BoxComponent
            id={itemId}
            key={item.id}
            sx={{
              backgroundColor: 'transparent',
              borderRadius: 0,
              textTransform: 'capitalize',
              ...(index === 0 ? {} : { ...getMargin() }),
            }}
          >
            <BoxComponent
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                width: '100%',
                ...(isDescription && item?.itemDescription
                  ? {
                      marginBottom: getScaleSize(normalizePixels(10, 'height'), scale),
                    }
                  : {}),
              }}
            >
              <BoxComponent
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: isItemPriceEnabled ? (item?.hasValidModifiers ? '48%' : '80%') : '100%',
                  columnGap: '10px',
                }}
              >
                <TypographyComponent
                  sx={{
                    color: template?.item?.itemName?.color ? template.item.itemName.color : '#242528',
                    fontWeight: template?.item.itemName.fontWeight,
                    fontStyle: template?.item.itemName.fontStyle,
                    letterSpacing: template?.item.itemName.letterSpacing,
                    lineHeight: template?.item.itemName.lineHeight,
                    fontFamily: fontFamily,
                    fontSize: getScaleSize(
                      normalizePixels(30 * Number(template?.item?.textScale ?? 1), 'height'),
                      scale
                    ),
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    minWidth: item?.outOfStock ? 'auto' : '100%',
                    maxWidth: getMaxWidth(),
                    '-webkit-line-clamp': '1',
                    '-webkit-box-orient': 'vertical',
                    ...(item.outOfStock ? { opacity: '30%' } : {}),
                  }}
                >
                  {item.itemName}
                </TypographyComponent>
                {item.outOfStock && <OutOfStock fontFamily={fontFamily} />}
              </BoxComponent>

              {isItemPriceEnabled && item?.hasValidModifiers && (
                <BoxComponent sx={{ width: '48%' }}>
                  {item.hasValidModifiers && (
                    <GridComponent container columnSpacing={1}>
                      {TEMPLATE_6_MODIFIERS.map((size) => (
                        <GridComponent key={size} item size={4}>
                          <TypographyComponent
                            sx={{
                              color: template?.item?.itemPrice?.color ? template?.item?.itemPrice?.color : '#242528',
                              textAlign: 'center',
                              fontFamily: fontFamily,
                              lineHeight: template.item.itemPrice.lineHeight,
                              fontWeight: template.item.itemPrice.fontWeight,
                              fontStyle: template.item.itemPrice.fontStyle,
                              letterSpacing: template.item.itemPrice.letterSpacing,
                              fontSize: getScaleSize(
                                normalizePixels(30 * Number(template?.item?.textScale ?? 1), 'height'),
                                scale
                              ),
                              ...(item.outOfStock ? { opacity: '30%' } : {}),
                            }}
                          >
                            {item.modifiers && item?.modifiers[size]
                              ? process.env?.NX_NODE_ENV === APP_ENV.UAT && tenantId === 2971
                                ? Number(item?.modifiers[size])
                                : Number(item?.modifiers[size]).toFixed(2)
                              : '-'}
                          </TypographyComponent>
                        </GridComponent>
                      ))}
                    </GridComponent>
                  )}
                </BoxComponent>
              )}

              {(!hasAnyModifier || !item.hasValidModifiers) && isItemPriceEnabled && (
                <TypographyComponent
                  sx={{
                    color: template?.item?.itemPrice?.color ? template?.item?.itemPrice?.color : '#242528',
                    textAlign: 'center',
                    fontFamily: fontFamily,
                    lineHeight: template.item.itemPrice.lineHeight,
                    fontWeight: template.item.itemPrice.fontWeight,
                    fontStyle: template.item.itemPrice.fontStyle,
                    letterSpacing: template.item.itemPrice.letterSpacing,
                    // width: '16%',
                    fontSize: getScaleSize(
                      normalizePixels(30 * Number(template?.item?.textScale ?? 1), 'height'),
                      scale
                    ),
                    ...(item.outOfStock ? { opacity: '30%' } : {}),
                  }}
                >
                  {Number(item.itemPrice).toFixed(2)}
                </TypographyComponent>
              )}
            </BoxComponent>

            {template?.itemDescription && item?.itemDescription && template?.itemDescription.isEnabled && (
              <TypographyComponent
                sx={{
                  color: template?.item?.itemDescription?.color ? template.item.itemDescription.color : '#242528',
                  fontFamily: fontFamily,
                  fontWeight: template.item.itemDescription?.fontWeight,
                  fontStyle: template.item.itemDescription?.fontStyle,
                  letterSpacing: template.item.itemDescription?.letterSpacing,
                  lineHeight: template.item.itemDescription?.lineHeight,
                  width: isItemPriceEnabled ? (hasAnyModifier ? '48%' : '80%') : '100%',
                  display: '-webkit-box',
                  overflow: 'hidden',
                  '-webkit-line-clamp': '2',
                  '-webkit-box-orient': 'vertical',
                  fontSize: getScaleSize(normalizePixels(18 * Number(template?.item?.textScale ?? 1), 'height'), scale),
                  ...(item.outOfStock ? { opacity: '30%' } : {}),
                }}
              >
                {item?.itemDescription}
              </TypographyComponent>
            )}
          </BoxComponent>
        )}
      </>
    )
  );
};

export default memo(Item);
